module.exports = __webpack_public_path__ + "static/media/bars-up.eecfd23b.svg";